import React from 'react';
import CardGrid from './CardGrid'
import CardDetails from './CardDetails'
import {Amplify, Storage } from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import awsconfig from '../aws-exports'; 
Amplify.configure(awsconfig);
Storage.configure({ level: "protected" });


const UserGrid = () => {
    return (
          
          <div className="ui grid">
            <div className="twelve wide column">
              <br/>
              <CardGrid gallery='false'/>
            </div>
            <div className="four wide column">
              <br/>
              <CardDetails/>
            </div> 
          </div>
      );
}

export default withAuthenticator(UserGrid, true);